import { SelectedInstrument } from "helpers/types/instruments/selected"
import useResource from "hooks/resources"

export interface AttributeCategory {
  id: string
  name: string
}

export function useAttributeCategories(instrument: SelectedInstrument) {
  return useResource<AttributeCategory[] | null>({
    resource: "attributeCategories",
    url: () => {
      if (!instrument.id || instrument.type !== "PORTFOLIO") {
        return null
      }
      return {
        id: `attributeCategories-${instrument.id}`,
        query: `query ($portfolioId: String!) {
          portfolio(id: $portfolioId) {
            positionAttributeCategories {
              id
              name
            }
          }
        }`,
        variables: { portfolioId: instrument.id },
      }
    },
  }, ["portfolio", "positionAttributeCategories"])
}
